module.exports = {
  src: __webpack_public_path__ + "static/media/individuals_00020_thumb.c46df715.jpg",
  width: 240,
  height: 300,
  bytes: 10676,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/individuals_00020_thumb.c46df715.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/individuals/individuals_00020_thumb.jpg
// module id = 454
// module chunks = 0